import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@abroad/components'
import AvailabilityPreviewModal from './AvailabilityPreviewModal'

const PreviewAvailability = ({ disabled, timezone }) => {
  const [show, setShow] = useState(false)
  return (
    <span className='d-flex ml-auto pl-3 preview-modal-wrapper'>
      <AvailabilityPreviewModal
        show={show}
        onHide={() => setShow(false)}
        timezone={timezone}
      />
      <Button
        variant='none'
        className='navTabs ml-0'
        style={{
          background: show ? '#0A223C' : '',
          color: show ? '#fff' : '',
        }}
        onClick={() => {
          if (disabled) return
          setShow(true)
        }}
        disabled={disabled}>
        SEE MY AVAILABILITY
      </Button>
    </span>
  )
}

PreviewAvailability.propTypes = {
  disabled: PropTypes.bool,
  timezone: PropTypes.string,
}

export default PreviewAvailability
